import React from "react";
import { NavLink, Route, Switch, Redirect } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import Products from "./SuperProducts";
import AddShopMenu from "./SuperAddShopMenu";
import SuperOrders from "./SuperOrder";
import EditProduct from "./EditProdcut";
import SuperAddProduct from "./SuperAddProduct";
import "../superShops.css";

const GET_SHOP = gql`
  query getShopByAdminForShopPage($id: ID!) {
    getShopByAdmin(id: $id) {
      _id
      name
      rootCategory {
        _id
        title
      }
    }
  }
`;

/**
 * ShopPage - the per-shop area: menu, products and orders for one shop.
 *
 * A restaurant calls its groupings a Menu of Menu items and its products
 * Foods; every other shop calls them Categories and Products. That
 * wording is decided once here from the shop's root category and passed
 * down, rather than each child screen querying the shop again to work it
 * out for itself.
 */
const ShopPage = (props) => {
  const shopId = props.match.params.id;
  const shopName = props.match.params.shopName;
  const base = `/superAdmin/${shopName}/${shopId}`;

  const { data } = useQuery(GET_SHOP, { variables: { id: shopId } });
  const shop = data && data.getShopByAdmin;
  const isRestaurant =
    shop && shop.rootCategory && shop.rootCategory.title === "Restaurant";

  const wording = {
    menu: isRestaurant ? "Menu" : "Categories",
    menuItem: isRestaurant ? "Menu item" : "Category",
    products: isRestaurant ? "Foods" : "Products",
    product: isRestaurant ? "Food" : "Product",
  };

  return (
    <div className="superShopShell">
      <nav className="superShopTabs">
        <NavLink className="superShopTab" activeClassName="isActive" to={`${base}/subMenus`}>
          {wording.menu}
        </NavLink>
        <NavLink className="superShopTab" activeClassName="isActive" to={`${base}/products`}>
          {wording.products}
        </NavLink>
        <NavLink className="superShopTab" activeClassName="isActive" to={`${base}/orders`}>
          Orders
        </NavLink>
      </nav>

      <Switch>
        <Route
          exact
          path="/superAdmin/:shopName/:id/addProductInShopMenu/:subMenuId"
          render={(routeProps) => (
            <SuperAddProduct
              theme="superAdmin"
              type="superAdmin"
              subMenuId={routeProps.match.params.subMenuId}
              id={shopId}
              shopName={shopName}
            />
          )}
        />
        <Route
          exact
          path="/superAdmin/:shopName/:id/editProduct/:productId"
          render={(routeProps) => (
            <EditProduct
              productId={routeProps.match.params.productId}
              id={shopId}
              shopName={shopName}
            />
          )}
        />
        <Route
          exact
          path="/superAdmin/:shopName/:id/products"
          render={() => (
            <Products
              key={`${shopId}-products`}
              id={shopId}
              shopName={shopName}
              shopTitle={shop && shop.name}
              wording={wording}
            />
          )}
        />
        <Route
          exact
          path="/superAdmin/:shopName/:id/orders"
          render={() => (
            <SuperOrders key={`${shopId}-orders`} id={shopId} shopTitle={shop && shop.name} />
          )}
        />
        <Route
          exact
          path="/superAdmin/:shopName/:id/subMenus"
          render={() => (
            <AddShopMenu
              key={`${shopId}-menu`}
              id={shopId}
              shopName={shopName}
              shopTitle={shop && shop.name}
              wording={wording}
            />
          )}
        />
        <Redirect from="/superAdmin/:shopName/:id" to="/superAdmin/:shopName/:id/subMenus" />
      </Switch>
    </div>
  );
};

export default ShopPage;
